import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { Event } from './types';

export type State = {
	endDate: Date;
	events: Event[];
	startDate: Date;
	searchTerm: string;
};

export const INITIAL_STATE: State = {
	searchTerm: '',
	events: ['all'],
	endDate: new Date(moment().format('YYYY-MM-DD')),
	startDate: new Date(moment().format('YYYY-MM-DD'))
};

const slice = createSlice({
	name: 'eventFilters',
	initialState: INITIAL_STATE,
	reducers: {
		filterReset: () => {
			return INITIAL_STATE;
		},
		filterChanged: (state, action: PayloadAction<Partial<State>>) => {
			return {
				...state,
				...action.payload
			};
		},
		eventsChanged: (state, action: PayloadAction<{ events: Event[] }>) => {
			const newEvents = action.payload.events.filter(event => !state.events.includes(event));
			const eventsWithoutRemoved = state.events.filter(
				event => !action.payload.events.includes(event) && (action.payload.events.length > 0 && event !== 'all')
			);
			const finalEvents = [...eventsWithoutRemoved, ...newEvents];
			state.events = finalEvents.length === 0 ? ['all'] : finalEvents;
		}
	}
});

export const { filterReset, filterChanged, eventsChanged } = slice.actions;

export default slice.reducer;
